import React from 'react';
import Card from './Card';
import PageBanner from '../../layout/PageBanner';
import { Link } from 'react-router-dom';
import './index.css';

const Publicaciones = (props) => (
  <div>
    <PageBanner title="Publicaciones" img="banner-publicaciones.jpg">
      <Link to="/">Home</Link>
      <Link to="/publicaciones">Publicaciones</Link>
    </PageBanner>

    <section className="blog-wrapper blog02">

      <div className="container">
        <div className="row">
          <div className="col-sm-12 section-header03">
            <h2><span>Nuestras</span> Publicaciones</h2>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-sm-10 col-md-10 col-sm-offset-1 col-md-offset-1 publicaciones">
            <div className="blog-six-content">
              <div className="row row-eq-height">
                {props.cards.length > 0 &&
                  props.cards.map((card, index) =>
                    <Card
                      id={card.id}
                      image={card.fields.Imagen ? card.fields.Imagen[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      imagenPrincipal={card.fields.ImagenPrincipal ? card.fields.ImagenPrincipal[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      title={card.fields.Titulo}
                      autor={card.fields.Autor}
                      description={card.fields.Descripcion}
                      pdf={card.fields.PDF ? card.fields.PDF[0].url : []}
                      key={`card${index}`}
                    />
                  )
                }
              </div>
            </div>
          </div>

          <div className="col-md-7 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2><span>Propiedad Intelectual</span></h2>
            </div>
          </div>
          <div className="col-md-12">
            <div className="course11-blocks">
              <div className="row" style={{marginBottom: "30px"}}>
                {props.publicPI.length > 0 &&
                  props.publicPI.map((card, index) =>
                    <Card
                      id={card.id}
                      image={card.fields.Imagen ? card.fields.Imagen[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      imagenPrincipal={card.fields.ImagenPrincipal ? card.fields.ImagenPrincipal[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      title={card.fields.Titulo}
                      autor={card.fields.Autor}
                      description={card.fields.Descripcion}
                      pdf={card.fields.PDF ? card.fields.PDF[0].url : []}
                      key={`card${index}`}
                    />
                  )
                }
              </div>
            </div>
          </div>


          <div className="col-md-7 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2><span>Cátedra OMC</span></h2>
            </div>
          </div>
          <div className="col-md-12">
            <div className="course11-blocks">
              <div className="row">
                {props.publicOMC.length > 0 &&
                  props.publicOMC.map((card, index) =>
                    <Card
                      id={card.id}
                      image={card.fields.Imagen ? card.fields.Imagen[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      imagenPrincipal={card.fields.ImagenPrincipal ? card.fields.ImagenPrincipal[0].thumbnails.large.url : 'https://via.placeholder.com/265x400.png?text=Flacso'}
                      title={card.fields.Titulo}
                      autor={card.fields.Autor}
                      description={card.fields.Descripcion}
                      pdf={card.fields.PDF ? card.fields.PDF[0].url : []}
                      key={`card${index}`}
                    />
                  )
                }
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </div>
);

export default Publicaciones;
